// extracted by mini-css-extract-plugin
module.exports = {"link":"ShoppingBagLink-module--link--1Y5ye","handle":"ShoppingBagLink-module--handle--1wqP-","bag":"ShoppingBagLink-module--bag--3rh44"};